import { render, staticRenderFns } from "./LiveRequest.vue?vue&type=template&id=cc0bfdaa&scoped=true"
import script from "./LiveRequest.vue?vue&type=script&lang=js"
export * from "./LiveRequest.vue?vue&type=script&lang=js"
import style0 from "./LiveRequest.vue?vue&type=style&index=0&id=cc0bfdaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0bfdaa",
  null
  
)

export default component.exports